import { makeFieldSchema } from '@backstage/plugin-scaffolder-react';

export const AdoProjectAndRepoPickerFieldSchema = makeFieldSchema({
    output: z => z.string(),
    uiOptions: z =>
        z.object({
            secretsKey: z
                .string()
                .describe(
                    'Key used within the template secrets context to store the credential',
                ),
        })
});

export type AdoProjectAndRepoPickerUiOptions = NonNullable<
    (typeof AdoProjectAndRepoPickerFieldSchema.TProps.uiSchema)['ui:options']
>;

export type AdoProjectAndRepoPickerProps = typeof AdoProjectAndRepoPickerFieldSchema.TProps;

export const AdoProjectAndRepoPickerSchema = AdoProjectAndRepoPickerFieldSchema.schema;